
export default (videoId) => ({
  video: null,
  isPresented: false,
  playing: false,

  init() {
    this.video = document.getElementById(videoId);
  },

  presentVideo() {

    if (this.isPresented) {
      if (this.video.paused) {
        this.video.play();
      }
      else {
        this.video.pause();
      }
    } else {
      this.video.muted = false; // Unmute the video
      this.video.currentTime = 0; // Reset to start
      this.video.play(); // Play the video
      this.playing = false;
      this.isPresented = true;
    }
  },
});
